import ThemedQuillEditor from'./themed-quill-editor.component';export default ThemedQuillEditor;export*from'./themed-quill-editor.component';